import { useState } from 'react';

import useNotifications from '@lib/hooks/notifications';
import { Slot, createComponent } from '@lib/util/templateHelpers';
import useForm from '@lib/hooks/form';
import shared from '@lib/components';
const { 
  Form, 
  Button, 
  Block, 
  Input,
  Select,
  RouterLink
} = shared;

import { useAuthStore } from '@/stores/auth'; 
import checkoutApi from '@/apis/drupal/checkout';
import { useRouter } from 'next/router';

export default createComponent('SpendTokensForm', {}, function LoginForm ({ className }, props) {
  const schema = {
    gameId: {
      value: '',
      schema: {
        type: Form.FIELD_ANY,
        required: true,
        acceptedValues: props.games.map((game) => ({
          value: game.nid,
          label: game.title
        }))
      }
    },
    tokensToSpend: {
      value: 1,
      schema: {
        type: Form.FIELD_NUMBER,
        minValue: 1,
        maxValue: props.maxTokens
      }
    }
  };

  // function to multiply the tokens
  // token = 1 week
  const multiplyTokens = (tokens) => {
	const days = tokens * 7;
    return days.toString();
  };

  const [ state ] = useAuthStore();
  const { notify } = useNotifications();
  const form = useForm(schema);
  const [ loading, setLoading ] = useState(false);
  const router = useRouter();

  const submit = async () => {
    const { data, hasErrors } = form.validate();
    if (hasErrors) return;

    setLoading(true);

    const result = await checkoutApi.spendTokens(props.uid, data.gameId, data.tokensToSpend, state.token);

    if (result.error) {
      notify('There was an error spending your tokens.');
      setLoading(false);
      return;
    }

    notify(`Success! Your game will be featured for ${multiplyTokens(data.tokensToSpend)} days.`);
    setLoading(false);
    router.push('/developer');
  };

  return (
    <Form className={className} schema={schema} onSubmit={submit}>
      <Block>
        <p>
          You currently have {props.maxTokens} tokens available to spend.&nbsp;
          <RouterLink href='/developer/purchase-tokens'>Purchase Tokens.</RouterLink>
        </p>
      </Block>

      <br />
      <Block>
        <Select.Field.List name='gameId' form={form} emptyLabel={'Choose a game'}>
          <Slot name='label'>Game to Promote</Slot>
        </Select.Field.List>

        <Input.Field name='tokensToSpend' type={Input.NUMBER} form={form}>
          <Slot name='label'>Number of Tokens to Spend</Slot>
        </Input.Field>
      </Block>
      
      <br />
      <Block>
        <Button primary submit disabled={form.hasErrors} loading={loading}>
          {props.buttonText || 'Spend Tokens'}
        </Button>
      </Block>
    </Form>
  );
});
